import React, { Component } from "react";
import { appendScript, removeElement } from '../utils/dom';
import { getClientProduct } from '../utils/request';
import { Link } from 'react-router-dom'
import { scrollTo } from "../utils/global";


export class ProductSlider extends Component {
    constructor(props) {
        super(props);

        this.state = {
            attrs :{
                class : "ProductSliderScript",
                src : "/js/component/ProductSlider.js",
                async : true,
            },
            remove : ".ProductSliderScript", // string or array
            product : [],
			update: false
        };
    }

    componentDidMount() {
        const { attrs, remove } = this.state
        const { ClientId } = this.props
		getClientProduct().then((res)=>{
            let result = []
            for(var i=0; i<res.length; i++){
                var r = res[i]
                if(r.CLIENTS_ID!==ClientId){ continue }
                result.push(r)
            }
            this.setState({ product : result })
            window.g.ProductSliderLength = result.length
            appendScript(attrs,remove)
		})
    }
    
    componentDidUpdate(prevProps, prevState, snapshot) {
		if(prevProps.update===true || prevProps.ClientId!==this.props.ClientId){
            this.componentDidMount()
        }
    }

    componentWillUnmount(){
        const { remove } = this.state
        removeElement(remove)
    }

    render() {
        const { main } = this.props
        const { product } = this.state
        const title = (this.props.productTag!==undefined)? this.props.productTag.title
            : (main.language)? main.language.MENU_PRODUCT : "-"
        if(product.length<1){ return("") }
        return (
            <div className="product-member-slider-area section-space--inner--top--40" id="Product">
                <div className="container">
                    {(this.props.productTag!==undefined && this.props.productTag.removeHeader===true)?
                        <div></div>
                    :
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="career-title-area text-center section-space--bottom--50">
                                    <h2 className="title">{ title }</h2>
                                    <p className="subtitle">Professional ethics govern the values of social responsibility that help us deliver our obligations within a coherent social framework.</p>
                                </div>
                            </div>
                        </div>
                    }

                    <div className="row">
                        <div className="col-lg-12">
                            <div className="product-slider">
                                <div className="swiper-container product-slider__container">
                                    <div className="swiper-wrapper product-slider__wrapper">
                                        {product.map((p,i) => (
                                            <div key={"mentors-"+i} className="swiper-slide">
                                                <div className="product-slider__single">
                                                    <div className="image">
                                                        <Link to={"/product/"+p.SLUG} target="_self" onClick={(el)=>{ scrollTo(el) }}>
                                                            <img src={p.FULL_PATH_IMAGE} className="img-fluid" alt=""/>
                                                        </Link>
                                                    </div>
                                                    <div className="content">
                                                        <div className="identity-wrapper has-border-left single-case-study-project__content">
                                                            <h3 className="name title">
                                                                <Link to={"/product/"+p.SLUG} target="_self" onClick={(el)=>{ scrollTo(el) }}>
                                                                    {p.TITLE}
                                                                </Link>
                                                            </h3>
                                                            <span className="designation">{p.SUB_TITLE}</span>
                                                        </div>
                                                        <div className="social-links social-links--white-topbar d-inline-block">
                                                            <ul>
                                                                <li>
																	<a href="//facebook.com">
																		<i className="ion-social-facebook"></i>
																	</a>
																</li>
                                                                <li>
																	<a href="//twitter.com">
																		<i className="ion-social-twitter"></i>
																	</a>
																</li>
                                                                <li>
																	<a href="//linkedin.com">
																		<i className="ion-social-linkedin"></i>
																	</a>
																</li>
                                                                <li>
																	<a href="//skype.com">
																		<i className="ion-social-skype"></i>
																	</a>
																</li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="ht-swiper-button-prev ht-swiper-button-prev-14 ht-swiper-button-nav">
									<i className="ion-chevron-left"></i>
								</div>
                                <div className="ht-swiper-button-next ht-swiper-button-next-14 ht-swiper-button-nav">
									<i className="ion-chevron-right"></i>
								</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ProductSlider;